<template>
    <div>
        <i-table ref="table" :data="table.data" :columns="table.columns">
            <table slot="footer" class="w-full">
                <tfoot>
                    <tr class="ivu-table-row">
                        <td class>
                            <div class="ivu-table-cell">
                                <span>Total</span>
                            </div>
                        </td>
                        <td v-for="(value, key) in table.total" :key="key" class>
                            <div class="ivu-table-cell">
                                <span>{{value}}</span>
                            </div>
                        </td>
                    </tr>
                </tfoot>
            </table>
        </i-table>
    </div>
</template>

<script>
import utils from './Mixins/Utils';
import { revendaApi } from "@/api/axios";

export default {
    mixins: [utils],
    name: 'regiao',
    data () {
        return {
            config: {
                periodRange: 13,
                monthLabel: ["Jan", "Fev", "Mar", "Abr", "Mai", "Jun", "Jul", "Ago", "Set", "Out", "Nov", "Dez"],
                monthRange: []
            },
            table: {
                columns: [],
                data: []
            }
        }
    },

    methods: {
        async getCompaniesByStates()
        {
            const {data} = await revendaApi.get('stats/companies/states');
            const states = new Set(data.flatMap(row => row.estado));
            const values = [];

            states.forEach(state => {
                const row = {};
                this.config.monthRange.forEach(period => {
                    row[period] = 0;
                });
                const periods = data.filter(period => period.estado === state).forEach(period => {
                    const periodInfo = period.periodo.split('-');
                    row[`${this.config.monthLabel[periodInfo[1] - 1]} ${periodInfo[0]}`] = period.total;
                });
                row.estado = state;
                values.push(row);
            });

            const total = {};
            this.config.monthRange.forEach(period => {
                total[period] =  _.sumBy(values, state => state[period]);
            });

            this.table.total = total;
            this.table.data = _.orderBy(values, [this.config.monthRange[this.config.monthRange.length - 1]], ['desc']);
        },

        fillColumns () {
            const period_table = this.config.monthRange.map(period => ({title:period, key: period, sortable: true}));
            this.table.columns = [
                {
                    title: 'Estado',
                    key: 'estado',
                    sortable:true,
                    fixed:true
                },
                ...period_table
            ];
        }
    },

    created()
    {
        this.loadPeriodRange();
        this.fillColumns();
        this.getCompaniesByStates();
    }
}
</script>

<style scoped>

</style>
